<div class="footer" [ngClass]="{'with-menu': withMenu}"
     fxLayout="row" fxLayoutAlign="space-between center"
     fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="space-evenly center">
    <img src="assets/logo_footer.png" class="footer-logo start" [alt]="'Logo'|i18n">
    <div *ngIf="version" class="footer-version">{{ 'CER Manager V.{0}'|i18n:version }}</div>
    <div class="footer-text">{{ copyright }}</div>
    <div *ngIf="address" class="new-line footer-text">{{ address }}</div>
    <ng-container *appVar="(!isCustomerCareSelected && customerCareEnabled|async) as showCustomerCare">
        <a [href]=cookiesLink target="_blank" rel="noopener noreferrer" class="footer-text" [ngClass]="{'end': !showCustomerCare}">Cookie Policy</a>
        <div *ngIf="showCustomerCare" class="end">
            <button app-ghost-button (click)="onClickSupport()">
                <app-icon name="fal-question-circle"></app-icon>
                <div>{{ 'Customer support'|i18n }}</div>
            </button>
        </div>
    </ng-container>
</div>
